import { render, staticRenderFns } from "./MyCoursesNewContentToggle.vue?vue&type=template&id=43d4cfce&"
import script from "./MyCoursesNewContentToggle.vue?vue&type=script&lang=js&"
export * from "./MyCoursesNewContentToggle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports